export const opEdsData = [
  {
    id: 1,
    title:
      "Ontario is in trouble. It's time to reverse the decline of this proud province and chart a new course",
    author: "Project Ontario",
    date: "2025-06-07",
    excerpt: "Introducing Project Ontario: A new chapter for conservative renewal.",
    link: "https://thehub.ca/2025/06/07/ontario-is-in-trouble-its-time-to-chart-a-new-course-and-reverse-the-decline-of-this-proud-province/",
  },
  {
    id: 2,
    title: "Why Ontario needs a new Common Sense Revolution, 30 years later",
    author: "Matt Spoke",
    date: "2025-06-14",
    excerpt:
      "Ontario faces many of the same economic challenges that inspired the Common Sense Revolution, and it's time to rediscover that spirit.",
    link: "https://thehub.ca/2025/06/14/matt-spoke-why-ontario-needs-a-new-common-sense-revolution-30-years-later/",
  },
  {
    id: 3,
    title:
      "Ontario is missing millions of homes. Here's where the government is failing — and how it can actually make a meaningful difference",
    author: "Chris Spoke and Peter Copeland",
    date: "2025-07-08",
    excerpt:
      "Unlocking the domino effect of family-friendly housing is key to solving Ontario's affordability crisis.",
    link: "https://thehub.ca/2025/07/08/chris-spoke-and-peter-copeland-ontario-is-missing-millions-of-homes-heres-where-the-government-is-failling-and-how-it-can-actually-make-a-meaningful-difference/",
  },
  {
    id: 4,
    title: "Why Ontario should allow independent schools and unlock true choice in education",
    author: "Ginny Roth and Brian Dijkema",
    date: "2025-07-15",
    excerpt:
      "Allowing independent schools could provide parents with more choice and improve education outcomes across the province.",
    link: "https://thehub.ca/2025/07/15/ginny-roth-and-brian-dijkema-why-ontario-should-allow-independent-schools-and-unlock-true-choice-in-education/",
  },
  {
    id: 5,
    title: "The first job is disappearing, and young Canadians deserve better",
    author: "Matt Spoke and Alexander Brown",
    date: "2025-07-28",
    excerpt:
      "The disappearance of entry-level jobs is leaving young Canadians without the vital experiences that shape long-term success.",
    link: "https://thehub.ca/2025/07/28/matt-spoke-and-alexander-brown-the-first-job-is-disappearing-and-young-canadians-deserve-better/",
  },
  {
    id: 6,
    title: "Four ways to solve our growing crime crisis",
    author: "Adam Zivo and Josh Dehaas",
    date: "2025-08-07",
    excerpt:
      "From policing reform to smarter sentencing, here are four steps Ontario can take to curb rising crime.",
    link: "https://thehub.ca/2025/08/07/adam-zivo-and-josh-dehaas-four-ways-to-solve-our-growing-crime-crisis/",
  },
  {
    id: 7,
    title: "It's time for Ontario to take the private surgery option seriously",
    author: "Shawn Whatley and Josh Dehaas",
    date: "2025-08-21",
    excerpt:
      "Private options can relieve strain on the public system while maintaining universal access to care.",
    link: "https://thehub.ca/2025/08/21/shawn-whatley-and-josh-dehaas-its-time-for-ontario-to-take-the-private-surgery-option-seriously/",
  },
  {
    id: 8,
    title: "Ontario's economy is in trouble. Here's how to fix it",
    author: "Tim Sargent",
    date: "2025-08-29",
    excerpt:
      "Ontario's productivity gap threatens our prosperity — but clear, pro-growth reforms can turn things around.",
    link: "https://thehub.ca/2025/08/29/tim-sargent-ontarios-economy-is-in-trouble-heres-how-to-fix-it/",
  },
  {
    id: 9,
    title:
      "Poilievre's call to scrap the temporary foreign worker program is a good first step",
    author: "Alexander Brown",
    date: "2025-09-03",
    excerpt:
      "Canada's labour system is broken. Ending reliance on temporary foreign workers is a key part of rebuilding opportunity for Canadians.",
    link: "https://thehub.ca/2025/09/03/alexander-brown-and-michael-bonner-poilievres-call-to-kill-the-temporary-foreign-worker-program-is-a-good-first-step/",
  },
  {
    id: 10,
    title: "We want more doctors, TMU's DEI med school isn't the way",
    author: "Matt Spoke and Ariella Kimmel",
    date: "2025-09-12",
    excerpt:
      "Ontario's healthcare crisis won't be solved with ideological experiments — it needs pragmatic reform and expanded capacity.",
    link: "https://nationalpost.com/opinion/opinion-we-want-more-doctors-fords-dei-med-school-isnt-the-way",
  },
  {
    id: 11,
    title: "Ontario's auto era is over",
    author: "Matt Spoke",
    date: "2025-10-20",
    excerpt:
      "Ontario must pivot beyond legacy auto manufacturing and embrace new growth sectors.",
    link: "https://thehub.ca/2025/10/20/ontarios-auto-era-is-over/",
  },
  {
    id: 12,
    title: "How to Fix Ontario's Underperforming Childcare Program",
    author: "Peter Jon Mitchell",
    date: "2025-10-23",
    excerpt:
      "Ontario can deliver better childcare outcomes with targeted reforms that expand access and improve quality.",
    link: "https://thehub.ca/2025/10/23/need-to-know-a-tale-of-two-albertan-cities/",
  },
  {
    id: 13,
    title: "Ontario is now the wild west of safer supply drugs",
    author: "Adam Zivo",
    date: "2025-12-01",
    excerpt:
      "Ontario's safer supply program has become unregulated and requires urgent reform to prevent drug diversion.",
    link: "https://nationalpost.com/opinion/adam-zivo-ontario-is-now-the-wild-west-of-safer-supply-drugs",
  },
  {
    id: 14,
    title: "Get ready for a painful 2026, Ontario Commentary",
    author: "Matt Spoke",
    date: "2026-01-01",
    excerpt: "",
    link: "https://thehub.ca/2026/01/05/get-ready-for-a-painful-2026-ontario/",
  },
  {
    id: 15,
    title: "Ontario's Progressive Conservatives need a wake-up call",
    author: "Matt Spoke",
    date: "2026-01-30",
    excerpt: "",
    link: "https://thehub.ca/2026/01/30/ontarios-progressive-conservatives-need-a-wake-up-call/",
  },
  {
    id: 16,
    title: "I'm a conservative who believed in Doug Ford. His credibility is collapsing",
    author: "Matt Spoke",
    date: "2026-02-01",
    excerpt: "",
    link: "https://www.thestar.com/opinion/contributors/im-a-conservative-who-believed-in-doug-ford-his-credibility-is-collapsing/article_c9183c04-bbf1-484c-b45a-f104cb6253a4.html",
  },
];

